"use strict";
import _ from "underscore";
export default {
  groups: function(documentGroups) {
    return _.sortBy(documentGroups, (g) => {
      var asInt = parseInt(g.position);
      if (isNaN(asInt)) {
        return 1e4;
      } else {
        return asInt;
      }
    });
  },
  group: function(documentGroups, position) {
    return _.find(documentGroups, { position });
  },
  groupsFromDomSnapshot: function(domSnapshot, shouldShowNewGroup, shouldRemoveEmptyGroups) {
    var groups = this.actualGroupsFromDom(domSnapshot);
    if (shouldRemoveEmptyGroups) {
      groups = this.removeEmptyGroupsAndUpdatePositions(groups);
    }
    if (shouldShowNewGroup) {
      groups.push(this.buildNewGroup());
    }
    return groups.value();
  },
  actualGroupsFromDom: function(domSnapshot) {
    return _.chain(domSnapshot).sortBy(
      ([group]) => group.position === "ungrouped-browser" ? 1e4 : group.position === "unassociated" ? 9999 : 0
    ).map(([group, documentIds], i) => {
      const position = group.position === "ungrouped-browser" ? "ungrouped-browser" : group.position === "unassociated" ? "unassociated" : i + 1;
      return {
        position,
        factorInvoiceId: group.factorInvoiceId,
        documentIds,
        id: group.id,
        locked: group.locked,
        lockedReason: group.lockedReason
      };
    });
  },
  buildNewGroup() {
    return {
      position: "new",
      documentIds: [],
      id: null,
      locked: false,
      lockedReason: null
    };
  },
  removeEmptyGroupsAndUpdatePositions: function(groups) {
    let nextPosition = 1;
    return groups.reject(
      (group) => _.isEmpty(group.documentIds) && group.position !== "ungrouped-browser"
    ).each((group) => {
      if (group.position !== "ungrouped-browser" && group.position !== "unassociated") {
        group.position = nextPosition;
        nextPosition += 1;
      }
    });
  },
  allDocumentsAreGrouped: function(documentGroups) {
    return _.isEmpty(this.ungroupedBrowserGroup(documentGroups).documentIds);
  },
  ungroupedBrowserGroup(documentGroups) {
    return _.find(documentGroups, { position: "ungrouped-browser" });
  },
  groupedDocuments: function(documentGroups) {
    return _.flatten(_.select(documentGroups, this.isActualGroup));
  },
  isActualGroup(group) {
    return !_.includes(
      ["new", "ungrouped-browser", "unassociated", null],
      group.position
    );
  },
  actualGroups: function(documentGroups) {
    return _.select(documentGroups, this.isActualGroup);
  }
};
